const arr = ['Number', 'String', 'Function', 'Array', 'Object', 'Date']
arr.forEach((item, i) => {
  window[`is${item}`] = (str2) => {
    return Object.prototype.toString.call(str2) === `[object ${item}]`
  }
})

const getTimeStr = (time, isShort = false, interval = '-') => {
  if (time == undefined || !time) {
    return '-'
  }
  if (isNumber(time)) time = new Date(time)
  if (!isDate(time)) return time
  let format = isShort ? `YYYY${interval}MM${interval}dd` : 'YYYY-MM-dd hh:mm:ss'
  const date = {
    'M+': time.getMonth() + 1,
    'd+': time.getDate(),
    'h+': time.getHours(),
    'm+': time.getMinutes(),
    's+': time.getSeconds(),
    'q+': Math.floor((time.getMonth() + 3) / 3),
    'S+': time.getMilliseconds(),
  }
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in date) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length),
      )
    }
  }
  return format
}

window.dateFormate = getTimeStr

Date.prototype.format = function(format) {
  var date = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S+': this.getMilliseconds(),
  }
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in date) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length),
      )
    }
  }
  return format
}
